import React from 'react';
import { Link } from 'react-router-dom';
import '../Legal.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Вернуться на главную</Link>
        
        <h1>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ (ПУБЛИЧНАЯ ОФЕРТА)</h1>
        
        <div className="legal-info">
          <p><strong>Постоянный адрес публикации:</strong> https://duh-prim.ru/terms</p>
          <p><strong>Дата публикации:</strong> {new Date().toLocaleDateString('ru-RU')}</p>
        </div>

        <p className="intro">
          Индивидуальный предприниматель Бурков Максим Артурович, действующий на основании 
          ОГРНИП 325253600073026, именуемый в дальнейшем «Продавец», публикует настоящую 
          Публичную оферту о продаже товаров дистанционным способом.
        </p>

        <section>
          <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
          <p><strong>1.1.</strong> Настоящее Соглашение определяет порядок розничной купли-продажи 
          Товаров через Интернет-магазин, расположенный по адресу https://duh-prim.ru.</p>
          
          <p><strong>1.2.</strong> Заказывая Товары через Интернет-магазин, Пользователь соглашается 
          с условиями настоящего Соглашения. В случае несогласия Пользователь обязан прекратить 
          использование сервиса.</p>
          
          <p><strong>1.3.</strong> Интернет-магазин предназначен для пользователей старше 18 лет.</p>
        </section>

        <section>
          <h2>2. ПРЕДМЕТ СОГЛАШЕНИЯ</h2>
          <p><strong>2.1.</strong> Продавец обязуется передать в собственность Покупателя, 
          а Покупатель обязуется оплатить и принять Товар (наборы для приготовления настоек, 
          ингредиенты, аксессуары).</p>
          
          <div className="warning">
            <p><strong>2.2. Важное предупреждение:</strong></p>
            <ul>
              <li>Реализуемые товары являются пищевыми концентратами/ингредиентами. 
              Продавец не осуществляет реализацию этилового спирта и алкогольной продукции.</li>
              <li>Товары не являются лекарственными средствами или БАДами (если иное прямо 
              не указано на упаковке с соответствующей сертификацией).</li>
              <li>Продавец не несет ответственности за возможные индивидуальные аллергические 
              реакции на компоненты (травы, специи, ягоды).</li>
            </ul>
          </div>
        </section>

        <section>
          <h2>3. ПОРЯДОК ПОКУПКИ И ЦЕНА</h2>
          <p><strong>3.1.</strong> Цена Товара указывается на сайте. В случае неверного указания 
          цены заказанного Товара, Продавец информирует об этом Покупателя для подтверждения 
          Заказа по исправленной цене либо аннулирования Заказа.</p>
          
          <p><strong>3.2.</strong> Цена на Товар может быть изменена Продавцом в одностороннем 
          порядке. При этом цена на уже заказанный и оплаченный Покупателем Товар изменению 
          не подлежит.</p>
          
          <p><strong>3.3.</strong> Фотографии Товара являются иллюстрациями и могут отличаться 
          от фактического внешнего вида Товара (например, оттенок упаковки или фракция помола трав).</p>
        </section>

        <section>
          <h2>4. ПЕРСОНАЛЬНЫЕ ДАННЫЕ</h2>
          <p><strong>4.1.</strong> Принимая условия настоящей Оферты, Покупатель дает согласие 
          на обработку своих персональных данных в соответствии с Федеральным законом № 152-ФЗ 
          «О персональных данных».</p>
          
          <p><strong>4.2.</strong> Подробные условия обработки, хранения и защиты данных 
          регулируются <Link to="/privacy-policy">Политикой конфиденциальности</Link>.</p>
          
          <p><strong>4.3.</strong> Состав собираемых данных: ФИО, контактный телефон, 
          электронная почта, адрес доставки.</p>
          
          <p><strong>4.4.</strong> Покупатель соглашается на получение от Продавца 
          информационных сообщений (смс, e-mail) о статусе заказа. Согласие на получение 
          рекламных рассылок оформляется Покупателем дополнительно (путем подписки на сайте) 
          и может быть отозвано в любой момент.</p>
        </section>

        <section>
          <h2>5. ДОСТАВКА И ОПЛАТА</h2>
          <p><strong>5.1.</strong> Способы, сроки и стоимость доставки указываются на сайте 
          при оформлении Заказа. Конечная стоимость зависит от тарифов выбранной транспортной 
          службы (Почта России, СДЭК и др.).</p>
          
          <p><strong>5.2.</strong> Обязательство Продавца по передаче Товара считается 
          исполненным в момент сдачи товара перевозчику. Риск случайной гибели или повреждения 
          Товара переходит к Покупателю с момента передачи Товара перевозчику.</p>
        </section>

        <section>
          <h2>6. ВОЗВРАТ ТОВАРА И ПРЕТЕНЗИИ</h2>
          <p><strong>6.1.</strong> Продовольственные товары (наборы трав и специй) надлежащего 
          качества возврату и обмену не подлежат.</p>
          
          <p><strong>6.2.</strong> В случае обнаружения брака или товара ненадлежащего качества, 
          Покупатель вправе потребовать замены или возврата средств. Претензии принимаются 
          по электронной почте <a href="mailto:duh_primorye@mail.ru">duh_primorye@mail.ru</a> 
          с приложением фотофиксации недостатков.</p>
        </section>

        <section>
          <h2>7. ОТВЕТСТВЕННОСТЬ</h2>
          <p><strong>7.1.</strong> Продавец не несет ответственности за ущерб, причиненный 
          Покупателю вследствие ненадлежащего использования Товаров.</p>
          
          <p><strong>7.2.</strong> Продавец не несет ответственности за вкусовые качества 
          и безопасность готового напитка, изготовленного Покупателем, так как результат 
          зависит от качества используемой алкогольной основы и соблюдения Покупателем 
          технологии настаивания.</p>
        </section>

        <section className="contacts">
          <h2>8. РЕКВИЗИТЫ ПРОДАВЦА</h2>
          <div className="contact-info">
            
            <div className="contact-details">
              <h3>ИП Бурков Максим Артурович</h3>
              <p>ОГРНИП: 325253600073026</p>
              <p>ИНН: 250822172828</p>
              <p>Адрес: Приморский край, г. Находка</p>
            </div>
            <div className="contact-details">
              <h3>Контакты для связи:</h3>
              <p>📞 <a href="tel:+79915376731">+7 (991) 537-67-31</a> (Москва)</p>
              <p>📞 <a href="tel:+79940081324">+7 (994) 008-13-24</a> (Дальний Восток)</p>
              <p>📧 <a href="mailto:duh_primorye@mail.ru">duh_primorye@mail.ru</a></p>
          </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
